import * as $ from 'jquery';

let svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
	<path d="m20,0C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0Zm0,36c-8.84,0-16-7.16-16-16S11.16,4,20,4s16,7.16,16,16-7.16,16-16,16Z"/>
	<path class="svg-path-v" d="m22,18v-4c0-1.1-.9-2-2-2s-2,.9-2,2v12c0,1.1.9,2,2,2s2-.9,2-2v-8Z"/>
	<path class="svg-path-h" d="m22,22h4c1.1,0,2-.9,2-2s-.9-2-2-2h-12c-1.1,0-2,.9-2,2s.9,2,2,2h8Z"/>
</svg>`;

document.addEventListener('DOMContentLoaded', function() {
    // Hide all 'childWrap' elements by default
    $('.nav--footer .childWrap').hide();

    $('.nav--footer .menu-item-has-children > a').each(function() {
        $(this).append(svg);
    });

    // Add click event handler to 'li' elements with the specified class
    $('.nav--footer .menu-item-has-children a').on('click', function(event) {
        // if it's a heading, don't do any default actions
        if($(this).attr('href') === '#') {
            event.preventDefault();
        }
        // Toggle the display of the corresponding 'childWrap' element
        $(this).next('.childWrap').slideToggle();

        // Toggle the 'open' class on the clicked 'li' element
        $(this).toggleClass('open');
    });
});
